import React, { useState } from 'react';
import { Card, Select, Button, Row, Col, Typography, message } from 'antd';
import { QrcodeOutlined, SaveOutlined } from '@ant-design/icons';
import { QRCodeSVG } from 'qrcode.react';
import { stores } from '../mockData';

const { Title, Text } = Typography;
const { Option } = Select;

const QRCodePage = ({ user }) => {
  const [selectedStore, setSelectedStore] = useState(user.storeId || null);
  
  // 检查当前用户是否有权限
  const checkPermission = () => {
    return ['boss', 'manager'].includes(user.role);
  };

  // 获取当前用户可见的门店列表
  const getVisibleStores = () => {
    if (user.role === 'boss') {
      return stores;
    } else {
      return stores.filter(store => store.id === user.storeId);
    }
  };

  // 生成会员注册二维码数据
  const generateQRCodeData = () => {
    // 实际场景中这应该是一个指向会员注册页面的URL，包含门店参数
    // 这里为了模拟效果，使用一个虚构的URL
    if (!selectedStore) return '';
    const store = stores.find(s => s.id === selectedStore);
    if (!store) return '';
    
    return `https://member-register.example.com?store_id=${store.id}&store_name=${encodeURIComponent(store.name)}`;
  };

  // 保存二维码
  const handleSaveQRCode = () => {
    message.success('二维码已保存到相册');
  };

  if (!checkPermission()) {
    return (
      <Card title="会员二维码">
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Text type="danger">您没有权限访问此页面</Text>
        </div>
      </Card>
    );
  }

  return (
    <Card title="会员注册二维码">
      <Row gutter={[16, 24]}>
        <Col span={24}>
          <div style={{ marginBottom: 16 }}>
            <Text>选择门店生成会员注册二维码，顾客扫码后可直接注册会员。</Text>
          </div>
          <Select
            placeholder="请选择门店"
            style={{ width: 200 }}
            value={selectedStore}
            onChange={value => setSelectedStore(value)}
            disabled={user.role === 'manager'} // 店长不能选择其他门店
          >
            {getVisibleStores().map(store => (
              <Option key={store.id} value={store.id}>
                {store.name}
              </Option>
            ))}
          </Select>
        </Col>

        {selectedStore && (
          <>
            <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="scan-area">
                <Title level={4} style={{ marginBottom: 24 }}>
                  {stores.find(s => s.id === selectedStore)?.name} - 扫码成为会员
                </Title>
                <div style={{ 
                  background: 'white', 
                  padding: 16, 
                  display: 'inline-block',
                  border: '1px solid #f0f0f0',
                  borderRadius: 4,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}>
                  <QRCodeSVG 
                    value={generateQRCodeData()} 
                    size={200}
                    level="H"
                    imageSettings={{
                      src: "https://img.icons8.com/color/96/000000/membership-card.png",
                      height: 35,
                      width: 35,
                      excavate: true,
                    }}
                  />
                </div>
                <div style={{ marginTop: 24 }}>
                  <Button 
                    type="primary" 
                    icon={<SaveOutlined />}
                    onClick={handleSaveQRCode}
                  >
                    保存二维码
                  </Button>
                </div>
              </div>
            </Col>

            <Col span={24}>
              <div style={{ 
                background: '#f9f9f9', 
                padding: 16, 
                borderRadius: 4, 
                border: '1px dashed #d9d9d9' 
              }}>
                <Title level={5}>使用说明:</Title>
                <ol style={{ paddingLeft: 20 }}>
                  <li>将此二维码放置在门店前台或通过微信群发送给潜在会员</li>
                  <li>顾客扫码后，可填写个人信息注册成为会员</li>
                  <li>系统会自动将会员关联到当前选择的门店</li>
                  <li>注册成功后，系统会显示会员卡号和初始积分</li>
                </ol>
              </div>
            </Col>
          </>
        )}
      </Row>
    </Card>
  );
};

export default QRCodePage; 